import PropTypes from "prop-types";
import React, {useState, useCallback, useEffect, useRef} from "react";

import {Toolbar} from "controls/react/layout/toolbar";
import {Section} from "controls/react/layout/section";
import {IconButton} from "../form/iconButton";

import './collapsibleFrame.less';
import classnames from 'classnames';
import {i18n} from 'core/localization';

export function CollapsibleFrame(rawProps) {
	const props = { hideCollapsedPlaceholder: false, ...rawProps, expanded: rawProps.expanded ?? true };
	const [state, setState] = useState(props.expanded);

	const onToggle = useCallback(() => {
		if (props.disabled) {
			return;
		}
		setState(!state);
		props.onChange?.(!state);
	}, [state, props.disabled]);

	useEffect(() => {
		if (state != props.expanded) {
			setState(props.expanded);
		}
	}, [props.expanded]);

	const Switcher = props.switcher;
	const classes = classnames(...([props.className, props.hideCollapsedPlaceholder && !state ? 'hide-collapsed-placeholder': ''].filter(x => x != undefined)));
	return <Section appearance={"frame"} className={classes} childrenPadding={props.childrenPadding}>
		<Toolbar title={props.title} >
			{!props.switcher && <IconButton iconName={state ? 'minus' : 'unchecked'}
			            onClick={onToggle}
			            embedded={true}/>}
			{props.switcher && <Switcher disabled={props.disabled} enabled={state} onChange={onToggle}></Switcher>}
		</Toolbar>
		{state && !props.disabled && props.children}
		{!state && props.alwaysShowFields && props.children}
		{(!state || props.disabled) && !props.hideCollapsedPlaceholder && <span onClick={onToggle} className={"collapsible-frame-maximize"}>{i18n('Click here or maximize icon to see setting')}</span>}
	</Section>
}

CollapsibleFrame.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string,
	expanded: PropTypes.bool,
	hideCollapsedPlaceholder: PropTypes.bool,
	onChange: PropTypes.func,
	childrenPadding: PropTypes.bool
};

export default CollapsibleFrame;
